import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
var _excluded = ["node"],
    _excluded2 = ["node"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(iterate),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(iterateBreadthFirst);

import _regeneratorRuntime from "@babel/runtime/regenerator";
import { top } from './array';
import { getObjectField, hasOwnProperty, omit } from './object';
/**
 * 节点配置
 * @typedef {Object} NodeConfig
 * @property {Function|String} [childrenName='children'] 如果获取节点的children
 * @property {Function|String} [valueName='value'] 如果获取节点的key
 */

/**
 * 树节点
 * @typedef {Object} Node
 * @property {Node[]} children 子节点
 */

/**
 * 树
 * @typedef {Node[]} Tree
 */

/**
 * item回调参数
 * @typedef {Object} NodeCallbackArgs
 * @property {number} level 节点所在层级，从0开始计数
 * @property {Node[]} path 从根节点到该节点所构成的数组
 */

/**
 * item回调
 * @callback NodeCallback
 * @param {Node} node
 * @param {NodeCallbackArgs} args
 */

/**
 *
 * 获取一个对象的值
 * @export
 * @param {*} obj
 * @param {Function|String} objectKey 如果是函数，返回对这个函数的调用并传入obj，如果是字符串，返回obj[objectKey]
 * @returns 结果
 */
// function getObjectValue(obj, objectKey) {
//     return isString(objectKey) ? obj[objectKey] : objectKey(obj);
// }

/**
 *
 * 迭代树
 * @export
 * @param {Tree} tree 树
 * @param {NodeConfig} config 节点配置
 * @returns {Generator<Node>} 迭代器
 */

export function iterate(tree) {
  var _marked,
      _ref,
      _ref$childrenName,
      childrenName,
      iterateA,
      _args2 = arguments;

  return _regeneratorRuntime.wrap(function iterate$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          iterateA = function _iterateA(list, parent, level) {
            var i, node, children, path;
            return _regeneratorRuntime.wrap(function iterateA$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    i = 0;

                  case 1:
                    if (!(i !== list.length)) {
                      _context.next = 12;
                      break;
                    }

                    node = list[i];
                    children = node[childrenName];
                    path = parent.concat(node);
                    _context.next = 7;
                    return {
                      parent: top(parent),
                      node: node,
                      path: path,
                      level: level
                    };

                  case 7:
                    if (!children) {
                      _context.next = 9;
                      break;
                    }

                    return _context.delegateYield(iterateA(children, path, level + 1), "t0", 9);

                  case 9:
                    ++i;
                    _context.next = 1;
                    break;

                  case 12:
                  case "end":
                    return _context.stop();
                }
              }
            }, _marked);
          };

          _marked = /*#__PURE__*/_regeneratorRuntime.mark(iterateA);
          _ref = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {}, _ref$childrenName = _ref.childrenName, childrenName = _ref$childrenName === void 0 ? 'children' : _ref$childrenName;
          return _context2.delegateYield(iterateA(tree, [], 0), "t0", 4);

        case 4:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
/**
 *
 * 迭代树，广度优先
 * @export
 * @param {Tree} tree 树
 * @param {NodeConfig} config 节点配置
 * @returns {Generator<Node>} 迭代器
 */

export function iterateBreadthFirst(tree) {
  var _ref2,
      _ref2$childrenName,
      childrenName,
      todo,
      _loop,
      _args4 = arguments;

  return _regeneratorRuntime.wrap(function iterateBreadthFirst$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _ref2 = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {}, _ref2$childrenName = _ref2.childrenName, childrenName = _ref2$childrenName === void 0 ? 'children' : _ref2$childrenName;
          todo = tree.concat([]).map(function (node) {
            return {
              level: 0,
              parent: [],
              node: node
            };
          });
          _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
            var _todo$shift, node, level, parent, children, path;

            return _regeneratorRuntime.wrap(function _loop$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _todo$shift = todo.shift(), node = _todo$shift.node, level = _todo$shift.level, parent = _todo$shift.parent;
                    children = node[childrenName];
                    path = parent.concat(node);
                    _context3.next = 5;
                    return {
                      node: node,
                      path: path,
                      level: level
                    };

                  case 5:
                    if (children) {
                      todo.push.apply(todo, _toConsumableArray(children.map(function (childNode) {
                        return {
                          node: childNode,
                          parent: path,
                          level: level + 1
                        };
                      })));
                    }

                  case 6:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _loop);
          });

        case 3:
          if (!todo.length) {
            _context4.next = 7;
            break;
          }

          return _context4.delegateYield(_loop(), "t0", 5);

        case 5:
          _context4.next = 3;
          break;

        case 7:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked3);
}
/**
 *
 * 遍历树
 * @export
 * @param {Tree} tree 树
 * @param {NodeCallback} doSomething 节点回调
 * @param {NodeConfig} config 节点配置
 */

export function traverse(tree, doSomething, nodeConfig) {
  var _iterator = _createForOfIteratorHelper(iterate(tree, nodeConfig)),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ref4 = _step.value;

      var node = _ref4.node,
          cxt = _objectWithoutProperties(_ref4, _excluded);

      doSomething(node, cxt);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
/**
 *
 * 创建一个新树，其结果是该树中的每个节点是调用一次提供的函数后的返回值。
 * @export
 * @param {Tree} tree 树
 * @param {NodeCallback} callback 生成新节点的函数
 * @param {NodeConfig} config 节点配置
 * @returns {Tree} 新树
 */

export function map(tree, callback) {
  var _ref5 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref5$childrenName = _ref5.childrenName,
      childrenName = _ref5$childrenName === void 0 ? 'children' : _ref5$childrenName;

  var result = [];

  function traverseA(list, parent, level, parentResult) {
    list.forEach(function (node) {
      var path = parent.concat(node);
      var newNode = callback(node, {
        path: path,
        level: level
      });
      parentResult.push(newNode);
      var children = node[childrenName];

      if (children) {
        var childrenResult = [];
        traverseA(children, path, level + 1, childrenResult);
        newNode[childrenName] = childrenResult;
      }
    });
  }

  traverseA(tree, [], 0, result);
  return result;
}
/**
 *
 * 创建一个新树, 包含通过所提供函数实现的测试的节点。
 * @export
 * @param {Tree} tree 树
 * @param {NodeCallback} callback 用来测试树中的每个节点的函数。返回true表示该元素通过测试，保留该元素，false则不保留。
 * @param {NodeConfig} config 节点配置
 * @returns {Tree} 新树
 */

export function filter(tree, callback) {
  var _ref6 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref6$childrenName = _ref6.childrenName,
      childrenName = _ref6$childrenName === void 0 ? 'children' : _ref6$childrenName;

  var result = [];

  function traverseA(list, parent, level, parentResult) {
    list.forEach(function (node) {
      var path = parent.concat(node);
      var ok = callback(node, {
        path: path,
        level: level,
        parent: top(parent)
      });

      if (ok) {
        var newNode = _objectSpread({}, node);

        parentResult.push(newNode);
        var children = node[childrenName];

        if (children) {
          var childrenResult = [];
          traverseA(children, path, level + 1, childrenResult);
          newNode[childrenName] = childrenResult;
        }
      }
    });
  }

  traverseA(tree, [], 0, result);
  return result;
}
/**
 *
 * 创建一个新树, 返回搜索结果。
 * @export
 * @param {Tree} tree 树
 * @param {NodeCallback} callback 用来测试树中的每个节点的函数。返回true表示该元素通过测试，保留该元素，false则不保留。
 * @param {NodeConfig} config 节点配置
 * @returns {Tree} 新树
 */

export function search(tree, callback) {
  var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref7$childrenName = _ref7.childrenName,
      childrenName = _ref7$childrenName === void 0 ? 'children' : _ref7$childrenName;

  var result = [];

  function traverseA(list, parent, level, parentResult, parentMatched) {
    var matched = false; // children是否

    list.forEach(function (node) {
      var path = parent.concat(node);

      var newNode = _objectSpread({}, node);

      var itemMatched = callback(node, {
        path: path,
        level: level
      }) || parentMatched; // 该节点是否匹配

      var children = node[childrenName];

      if (children) {
        var childrenResult = []; // children是否匹配

        var childrenMatched = traverseA(children, path, level + 1, childrenResult, itemMatched);
        itemMatched = itemMatched || childrenMatched;
        newNode[childrenName] = childrenResult;
      } // 如果匹配，加入到结果中


      if (itemMatched) {
        parentResult.push(newNode);
        matched = true;
      }
    });
    return matched;
  }

  traverseA(tree, [], 0, result, false);
  return result;
}
/**
 * 测试一个树内的所有节点是否都能通过某个指定函数的测试。它返回一个布尔值。
 * @export
 * @param {Tree} tree 树
 * @param {NodeCallback} callback 用来测试每个节点的函数
 * @param {NodeConfig} nodeConfig 节点配置
 * @returns 如果回调函数的每一次返回都为truthy值，返回true ，否则返回false。
 */

export function every(tree, callback, nodeConfig) {
  var _iterator2 = _createForOfIteratorHelper(iterate(tree, nodeConfig)),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _ref9 = _step2.value;

      var node = _ref9.node,
          cxt = _objectWithoutProperties(_ref9, _excluded2);

      if (!callback(node, cxt)) {
        return false;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return true;
}
/**
 * 返回一棵树的最大层级。
 * @export
 * @param {Tree} tree 树
 * @param {NodeConfig} nodeConfig 节点配置
 * @returns 结果
 */

export function getMaxLevel(tree, nodeConfig) {
  var maxLevel = 0;
  traverse(tree, function (_, _ref10) {
    var level = _ref10.level;
    maxLevel = Math.max(level, maxLevel);
  }, nodeConfig);
  return maxLevel + 1;
}
/**
 * 将树的节点展开为一个数组
 * @export
 * @param {Tree} tree 树
 * @param {NodeConfig} nodeConfig 节点配置
 * @returns 结果
 */

export function flat(tree, nodeConfig) {
  return _toConsumableArray(iterate(tree, nodeConfig));
}
export function tree(list) {
  var _ref11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref11$childrenName = _ref11.childrenName,
      childrenName = _ref11$childrenName === void 0 ? 'children' : _ref11$childrenName,
      _ref11$key = _ref11.key,
      getKey = _ref11$key === void 0 ? function (x) {
    return x;
  } : _ref11$key;

  var map = new Map();
  var noParentMap = new Map();

  var _iterator3 = _createForOfIteratorHelper(list),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _step3$value = _slicedToArray(_step3.value, 2),
          son = _step3$value[0],
          parent = _step3$value[1];

      var _map = [son, parent].map(function (n) {
        var key = getObjectField(n, getKey);
        var newNode = map.get(key);

        if (!map.has(key)) {
          newNode = omit(n, [childrenName]);
          map.set(key, newNode);
          noParentMap.set(newNode, true);
        }

        return newNode;
      }),
          _map2 = _slicedToArray(_map, 2),
          sonNode = _map2[0],
          parentNode = _map2[1];

      if (!hasOwnProperty(parentNode, childrenName)) {
        parentNode[childrenName] = [];
      }

      noParentMap.set(sonNode, false);
      parentNode[childrenName].push(sonNode);
    } // 根节点数组

  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return _toConsumableArray(map.values()).filter(function (n) {
    return noParentMap.get(n);
  });
}